import { supabase } from "@/integrations/supabase/client";

export const sendDevotional = async (date: string) => {
  try {
    // Check if subscription exists first
    const { data: existingSubscription } = await supabase
      .from('subscriptions')
      .select('*')
      .eq('contact', 'agbaye2000@gmail.com')
      .eq('type', 'email')
      .single();

    // If no subscription exists, we don't need to proceed
    if (!existingSubscription) {
      throw new Error('No subscription found for this email');
    }

    const { data, error } = await supabase.functions.invoke('send-daily-devotionals', {
      body: { 
        manual: true,
        specificDate: date,
        specificEmail: 'agbaye2000@gmail.com'
      }
    });

    if (error) throw error;
    return data;
  } catch (error) {
    console.error('Error sending devotional:', error);
    throw error;
  }
};